/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RemoveSharedWorkspaceResponse } from '../../models/remove-shared-workspace-response';

export interface RemoveSharedWorkspace$Params {
  workspaceId: number;
}

export function removeSharedWorkspace(http: HttpClient, rootUrl: string, params: RemoveSharedWorkspace$Params, context?: HttpContext): Observable<StrictHttpResponse<RemoveSharedWorkspaceResponse>> {
  const rb = new RequestBuilder(rootUrl, removeSharedWorkspace.PATH, 'delete');
  if (params) {
    rb.path('workspaceId', params.workspaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RemoveSharedWorkspaceResponse>;
    })
  );
}

removeSharedWorkspace.PATH = '/workspaces/shared/{workspaceId}';
